export class LanguageTemplateValidationError extends Error {
  public validations: string[]

  constructor(message: string, validations: string[]) {
    super(message)
    this.name = 'LanguageTemplateValidationError'
    this.validations = validations

    Object.setPrototypeOf(this, LanguageTemplateValidationError.prototype)
  }
}
